import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalog0getGetCatalogCurrentResponseSchema = jsonObject
export type tcpcatalog0getGetCatalogCurrentResponse = z.infer<typeof tcpcatalog0getGetCatalogCurrentResponseSchema>
export const tcpcatalog0getGetCatalogUseCasesResponseSchema = jsonObject
export type tcpcatalog0getGetCatalogUseCasesResponse = z.infer<typeof tcpcatalog0getGetCatalogUseCasesResponseSchema>
export const tcpcatalog0getGetCatalogUseCasesUseCaseKeyResponseSchema = jsonObject
export type tcpcatalog0getGetCatalogUseCasesUseCaseKeyResponse = z.infer<typeof tcpcatalog0getGetCatalogUseCasesUseCaseKeyResponseSchema>
export const tcpcatalog0getGetCatalogTestCasesResponseSchema = jsonObject
export type tcpcatalog0getGetCatalogTestCasesResponse = z.infer<typeof tcpcatalog0getGetCatalogTestCasesResponseSchema>
export const tcpcatalog0getGetCatalogPublicationsResponseSchema = jsonObject
export type tcpcatalog0getGetCatalogPublicationsResponse = z.infer<typeof tcpcatalog0getGetCatalogPublicationsResponseSchema>
export const tcpcatalog0getGetCatalogExportResponseSchema = jsonObject
export type tcpcatalog0getGetCatalogExportResponse = z.infer<typeof tcpcatalog0getGetCatalogExportResponseSchema>
export const tcpcatalog0getGetCatalogDraftsCurrentResponseSchema = jsonObject
export type tcpcatalog0getGetCatalogDraftsCurrentResponse = z.infer<typeof tcpcatalog0getGetCatalogDraftsCurrentResponseSchema>
